const FORMAT = /^\+[1-9][0-9]{1,14}$/

module.exports = function() {
  return value => value && FORMAT.test(value)
}
